import type { StyleLayer } from './utils/types'

export const layers_parkingLars_boundaries: StyleLayer[] = [
  {
    id: 'line-border-1',
    type: 'line',
    paint: {
      'line-color': '#664100',
      'line-opacity': 0.63,
      'line-width': 3,
    },
  },
  {
    id: 'line-border-1 copy',
    type: 'line',
    paint: {
      'line-color': '#664100',
      'line-offset': 4,
      'line-opacity': 0.3,
      'line-width': 4,
    },
  },
  {
    id: 'label copy 1',
    type: 'symbol',
    layout: {
      'symbol-avoid-edges': true,
      'symbol-placement': 'line-center',
      'text-allow-overlap': true,
      'text-field': ['to-string', ['get', 'name']],
      'text-justify': 'auto',
      'text-offset': [0, 0.7],
      'text-padding': 0,
      'text-size': 14,
    },
    paint: {
      'text-color': '#fffbeb',
      'text-halo-blur': 1,
      'text-halo-color': 'rgba(102, 65, 0, 0.65)',
      'text-halo-width': 3,
    },
  },
]
